import { useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const InterviewComponent= () => {
  const swiperRef = useRef<SwiperCore | null>(null);

  const handlePrevClick = () => {
    if(swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNextClick = () => {
    if(swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const interviewToUrl = (url: string) => {
    window.open(url, '_blank');
  };

  type InterviewImage = {
    pc: string;
    sp: string;
    name: string;
    entry_year: string;
    number: string;
    url: string;
  };
  
  const interviewImages: InterviewImage[] = [
    {
      pc: '/img/recruit/interview/interview-01-pc.jpg',
      sp: '/img/recruit/interview/interview-01-sp.jpg',
      name: 'M.W',
      entry_year: '2023年入社',
      number: 'No.01',
      url: 'https://reraku.jp/column/YT94rxxKZU',
    },
    {
      pc: '/img/recruit/interview/interview-02-pc.jpg',
      sp: '/img/recruit/interview/interview-02-sp.jpg',
      name: 'S.K',
      entry_year: '2018年入社',
      number: 'No.02',
      url: 'https://reraku.jp/column/GXGn5WFxFQ',
    },
    {
      pc: '/img/recruit/interview/interview_comingsoon-pc.jpg',
      sp: '/img/recruit/interview/interview_comingsoon-sp.jpg',
      name: '',
      entry_year: '',
      number: '',
      url: '',
    },
    {
      pc: '/img/recruit/interview/interview_comingsoon-pc.jpg',
      sp: '/img/recruit/interview/interview_comingsoon-sp.jpg',
      name: '',
      entry_year: '',
      number: '',
      url: '',
    },
    {
      pc: '/img/recruit/interview/interview_comingsoon-pc.jpg',
      sp: '/img/recruit/interview/interview_comingsoon-sp.jpg',
      name: '',
      entry_year: '',
      number: '',
      url: '',
    },
  ];

  return (
    <div className="recruit-interview">
      <h2 className="interview-title-pc"><img src="/img/recruit/interview/interview-title-pc.png" alt="インタビュー" /></h2>
      <h2 className="interview-title-sp"><img src="/img/recruit/interview/interview-title-sp.png" alt="インタビュー" /></h2>

      <div className="interview-swiper-container">
        <Swiper
          className="interview-swiper"
          spaceBetween={16}
          slidesPerView={2}
          loop={true}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          modules={[Navigation, Pagination, Autoplay]}
          pagination={{
            el: '.custom-swiper-pagination-sp',
            clickable: true,
          }}
          autoplay={{ delay: 5000 }}
          breakpoints={{
            769: {
              spaceBetween: 16,
              slidesPerView: 4,
              navigation: false,
            },
          }}
        >
          {interviewImages.map((image, index) => (
            <SwiperSlide
              key={index}
              className={image.url ? '' : 'coming-soon'}
              onClick={() => image.url && interviewToUrl(image.url)}
            >
              <div className={`interview-swiper-overlay ${image.url ? '' : 'coming-soon'}`}>
                <img src={image.pc} alt={`インタビュー${index + 1}`} className="interview-swiper-pc" />
                <img src={image.sp} alt={`インタビュー${index + 1}`} className="interview-swiper-sp"/>
                <p className="interview-number">{image.number}</p>
                <p className="interview-detail">Read more</p>
              </div>
              <div className="interview-info">
                <p className="interview-entry-year">{image.entry_year}</p>
                <h3 className="interview-name">{image.name}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="navigation-pagination-wrapper-sp">
          <img
            src="/img/recruit/recruit-chevron-left.svg"
            alt="前へ"
            className="swiper-button-prev-sp"
            onClick={handlePrevClick}
          />
          <div className="swiper-pagination custom-swiper-pagination-sp"></div>
          <img
            src="/img/recruit/recruit-chevron-right.svg"
            alt="次へ"
            className="swiper-button-next-sp"
            onClick={handleNextClick}
          />
        </div>

        <div className="navigation-pagination-wrapper-pc">
          <img
            src="/img/recruit/recruit-chevron-left.svg"
            alt="前へ"
            className="swiper-button-prev-pc"
            onClick={handlePrevClick}
          />
          <img
            src="/img/recruit/recruit-chevron-right.svg"
            alt="次へ"
            className="swiper-button-next-pc"
            onClick={handleNextClick}
          />
        </div>
      </div>
    </div>
  );
};

export default InterviewComponent;